import { useEffect, useState } from "react";
import styles from "../../../styles/search.module.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { lockScroll, unlockScroll } from "../../../shared/utils/scrollLock";

const Search = () => {
  const [isActive, setIsActive] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const activeSearch = searchParams.get("search") || "";
  const isGalleryPage = location.pathname === "/gallery";
  const targetPath = isGalleryPage ? "/gallery" : "/projects";

  function displaySearch() {
    setIsActive((prev) => !prev);
  }

  function handleSearch(e) {
    e.preventDefault();

    const trimmedQuery = searchQuery.trim();
    if (trimmedQuery) {
      navigate(`${targetPath}?search=${encodeURIComponent(trimmedQuery)}`);
    } else {
      navigate(targetPath);
    }
  }

  useEffect(() => {
    setSearchQuery(activeSearch);
  }, [activeSearch]);

  useEffect(() => {
    if (isActive) {
      lockScroll();
      return () => {
        unlockScroll();
      };
    }

    unlockScroll();
  }, [isActive]);

  useEffect(() => {
    setIsActive(false);
  }, [location]);

  return (
    <div className={styles.searchwrapper}>
      <svg
        onClick={displaySearch}
        width="30"
        height="30"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-search"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
        <path d="M21 21l-6 -6" />
      </svg>
      <form
        onSubmit={(e) => {
          handleSearch(e);
          displaySearch();
        }}
      >
        <div
          id="search"
          className={`${isActive ? styles.searchtextwrapper : styles.searchoff2}`}
        >
          <div onClick={displaySearch} className={styles.hidesearch}></div>

          <input
            type="text"
            placeholder={isGalleryPage ? "Search gallery..." : "Search projects..."}
            className={styles.searchinput}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button type="submit" className={styles.searchbutton}>
            <svg
              width="30"
              height="30"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-search"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
              <path d="M21 21l-6 -6" />
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

export default Search;
